import axios from "axios";
import { ElMessage, ElMessageBox } from "element-plus";
import router from "@/router";
// 设置基础路径
// const baseURL = "http://114.67.207.172:8004";
const baseURL = "http://114.117.204.133:8004";

// 创建一个 axios 实例
const requests = axios.create({
  baseURL: baseURL, // 所有的请求地址前缀部分
  timeout: 20 * 1000, // 请求超时时间毫秒
});

// 添加请求拦截器
requests.interceptors.request.use((config) => {
  // 在这里可以添加token👇
  // config.headers.token = "token"
  // config.headers.authorization = localStorage.getItem('Token') || ''
  // 添加token
  config.headers.Authorization =
    "Bearer " + window.localStorage.getItem("token") || "";
  config.headers["Content-type"] = "application/json;charset=UTF-8";
  return config;
});

// 添加响应拦截器
requests.interceptors.response.use(
  (response: any) => {
    // console.log(response)
    if (response.data.code === 200 || response.data.code === 0) {
      return response;
    } else {
      ElMessage({
        message: "提示："+response.data.msg,
        type: "error",
      });
      return Promise.reject(response);
    }
  },
  (error) => {
    // console.log(error.response.status);
    if (error.response.status == 401) {
      // 清除token
      window.localStorage.removeItem("token");
      // 保存当前地址以便登录后返回
      window.localStorage.setItem('loginurl',window.location.href)
      ElMessage({
        message: '请登录',
        type: "warning",
        duration: 1000,
        onClose: () => {
          // 跳转登录页
          router.push({
            path: "/login",
            query: {},
          });
        },
      });
    }
    return Promise.reject(error)
  }
);

export default requests;
